import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
    selector: 'gtw-credits-part-iii-f8936-wizard',
    templateUrl: './credits-part-iii-f8936-wizard.component.html',
    styleUrls: ['./credits-part-iii-f8936-wizard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreditsPartIIIF8936WizardComponent {
  @Input() activeWizardTab: 'Form 8936' | 'Schedule A' = 'Form 8936';
  @Input() activeTab: string = '';
  @Input() rowData: any = {};
  @Input() filterParams: any = {};
  @Input() globalService: any = {};
  @Input() generalConfig: any = {};
  @Input() userSettings: any = {};
  @Input() formDataObj: any = {};

  @Output() tabSelect = new EventEmitter<'Form 8936' | 'Schedule A'>();
  @Output() cancel = new EventEmitter<void>();

  onTabSelect(tab: 'Form 8936' | 'Schedule A'): void {
    this.tabSelect.emit(tab);
  }

  onSchACancel(): void {
    this.cancel.emit();
  }
}
